import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from '@angular/common';

@Component({
  standalone: false,
  selector: 'app-patient-portal-forms',
  templateUrl: './patient-portal-forms.component.html',
  styleUrls: ['./patient-portal-forms.component.css']
})
export class PatientPortalFormsComponent implements OnInit {

  FormId: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _location: Location
  ) { }

  ngOnInit() {

    if (this.route.params) {
      this.route.params.subscribe(parameters => {
        this.FormId = parameters.formId;
      });
    }


    console.log(this.FormId);

  }

  goBack() {
    this.router.navigateByUrl('/patientportal/home');
  }

}
